<template>
  <div class="app-container">
    <!--标题-->
    <div class="detailsTitle" style="margin-bottom: 0;">
      <h4>费目</h4>
    </div>
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini" style="width: 100%;">
        <div class=" formItemBox">
          <el-form-item label="费目名称:" prop="feeName">
            <el-input placeholder="" maxlength="100" v-model="searchFrom.feeName"></el-input>
          </el-form-item>
          <el-form-item label="创建人:" prop="createUser">
            <el-input placeholder="" maxlength="100" v-model="searchFrom.createUser"></el-input>
          </el-form-item>
          <el-form-item label="状态:" prop="validFlg">
            <el-select v-model="searchFrom.validFlg" placeholder="请选择">
              <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属租户:" prop="validFlg">
            <el-select v-model="searchFrom.tenantUnder" filterable clearable placeholder="请选择">
              <el-option v-for="(item,index) in tenantDataOptions" :key="index" :label="item.tenantName" :value="item.tenantCode">
              </el-option>
            </el-select>
          </el-form-item>
          </div>
          <div style="margin:10px 0 0 30px;">
            <el-form-item>
              <el-button type="primary" @click="feeChaXun" btnCode='000P00OB001' v-if="btnFlg[0]">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="chongZhi" btnCode='000P00OB002' v-if="btnFlg[1]">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addFeeInfoClick" btnCode='000P00OB003' v-if="btnFlg[2]">新增</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="spuChangeClick" btnCode='000P00OB004' v-if="btnFlg[3]">修改</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="spuDelBtnClick" btnCode='000P00OB005' v-if="btnFlg[4]">删除</el-button>
            </el-form-item>
          </div>

        <div class="searchBtnBox">
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:h}">
      <el-table :data="spuTableList" ref="spuTableList" border bordersize="mini" height="100%" style="width: 100%;margin-top:10px;" center :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}" @row-click="dianjixuanzhong" :row-style="{height:'35px'}" @selection-change="selectGoods" highlight-current-row>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="feeName" label="费目名称" align="center"></el-table-column>
        <el-table-column prop="sysName" label="费用业务" align="center"></el-table-column>
        <el-table-column prop="tenantName" label="所属租户" align="center" show-overflow-tooltip width="180"></el-table-column>
        <el-table-column prop="ext2" label="适用货物类型" align="center" show-overflow-tooltip width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.ext2==0">通用</span>
            <span v-else>非通用</span>
          </template>
        </el-table-column>
        <el-table-column property="createUser" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="dateFormat" width="200"></el-table-column>
        <el-table-column prop="validFlg" label="状态" align="center">
          <template slot-scope="scope">
            <div>
              <!--数据库： 0启用1停用 -->
              <span v-if="scope.row.validFlg =='0'">启用</span>
              <span v-if="scope.row.validFlg =='1'">停用</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="validFlg" label="费用明细字段" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="setUp(scope.row)" btnCode='000P00OB006' v-if="btnFlg[5]">设置</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="操作" align="center" width="180">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="startOrStopClick(scope.row)" btnCode='000P00OB008' v-if="scope.row.validFlg == '1' && btnFlg[7]">启用</el-button>
              <el-button type="text" size="small" @click="startOrStopClick(scope.row)" btnCode='000P00OB007' v-else-if="scope.row.validFlg == '0' && btnFlg[6]" :disabled="tingYongDisabled">停用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[1,10,25,50,100]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="spuTotal">
      </el-pagination>
    </div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>属性</h4>
    </div>
    <div class="searchBox2" ref="searchBox2">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox" style="margin-left:10px;">
          <el-form-item>
            <el-button type="primary" @click="addShuXIngClick" btnCode='000P00OB009' v-if="btnFlg[10]">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changeShuXingClick" btnCode='000P00OB00A' v-if="btnFlg[11]">修改</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delShuXingClick" btnCode='000P00OB00B' v-if="btnFlg[12]">删除</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:detailsH}">
      <el-table :data="tableData" ref="shuXingTabRef" border bordersize="mini" height="100%" style="width: 100%;margin-top:10px;" center :header-cell-style="{background:'#F5F5F5',color:'black'}" :header-row-style="{height:'45px'}" :row-style="{height:'35px'}" @row-click="dianjixuanzhong2" highlight-current-row>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="attrName" label="属性" align="center"></el-table-column>
        <el-table-column prop="attrStandard" label="字段名" align="center"></el-table-column>
        <el-table-column property="dsourceFlg" label="数据源类型" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.dsourceFlg == '1'">接口</span>
              <span v-else-if="scope.row.dsourceFlg == '2'">编码</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dataSource" label="数据源" align="center"></el-table-column>
        <el-table-column prop="attrDatatypeName" label="类型" align="center"></el-table-column>
        <el-table-column prop="interControlName" label="控件类型" align="center"></el-table-column>
        <el-table-column prop="orderBy" label="显示顺序" align="center"></el-table-column>
        <el-table-column prop="isnotFlg" label="是否必填" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.isnotFlg == '0'">是</span>
              <span v-else-if="scope.row.isnotFlg == '1'">否</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" :formatter="dateFormat" width="200"></el-table-column>
        <el-table-column prop="updateUser" label="修改人" align="center"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="attributePageNo" :page-sizes="[10,25,50,100]" :page-size="attributePageSize" layout="total, sizes, prev, pager, next, jumper" :total="attributeTotal">
      </el-pagination>
    </div>
    <!--新增费目-->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addSpuMark" width="500px" center>
      <span>
        <el-form :model="feeInfoAddFrom" :rules="rules" :validate-on-rule-change="false" ref="feeInfoAddFrom" class="demo-form-inline" label-width="140px" size="mini">
          <el-form-item label="费目名称:" prop="feeInfoAddName" style="margin-top:20px;">
            <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="feeInfoAddFrom.feeInfoAddName" style="width:200px;"></el-input>
          </el-form-item>
          <div class="addinpBox">
            <el-form-item label="费用业务:" prop="cost" style="margin-top:20px;">
              <el-select v-model="feeInfoAddFrom.cost" :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in costOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属租户:" prop="tenant" style="margin-top:20px;">
              <el-select v-model="feeInfoAddFrom.tenant" filterable clearable :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in tenantDataOptions" :key="index" :label="item.tenantName" :value="item.tenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费目分类:" prop='ext1' style="margin-top:20px;">
              <!-- <el-radio-group v-model="feeInfoAddFrom.ext1">
                <el-radio label="0">卷板</el-radio>
                <el-radio label="1">建材</el-radio>
              </el-radio-group> -->
              <el-select v-model="feeInfoAddFrom.ext1" filterable clearable :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in FeeTypeList" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="disShow" label="适用货物类型:" prop="ext2" style="margin-top:20px;">
              <el-radio-group v-model="feeInfoAddFrom.ext2">
                <el-radio :label="'0'">通用</el-radio>
                <el-radio :label="'1'">非通用</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' @click="addFeeInfoSubmit('feeInfoAddFrom')" v-if="addSpuBtn" :loading='addSpuLoading'>保存</el-button>
        <el-button type="primary" size='mini' @click="changeSpuSubmit('feeInfoAddFrom')" v-if="changeSpuBtn" :loading='changeSpuLoading'>修改</el-button>
        <el-button @click="addSpuClose('feeInfoAddFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!--新增属性-->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="addSpuShuXingMark" width="900px" center>
      <span>
        <el-form :model="feePropertyFrom" :rules="rules1" :validate-on-rule-change="false" ref="feePropertyFrom" class="demo-form-inline" label-width="140px" size="mini">
          <el-form-item label="属性个数:" prop="propertyNum" style="margin-top:20px;">
            <el-select v-model="propertyNum" @change="propertyNumChange(propertyNum)" :disabled="propertyNumDisabled" :validate-event="false" placeholder="请选择" style="width:200px;">
              <el-option v-for="(item,index) in propertyNumOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组合名称:" style="margin-top:20px;" v-if="propertyNum !='1'">
            <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="combinationName" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="字段名:" style="margin-top:20px;">
            <el-input placeholder="" maxlength="20" v-model.trim="fieldName" onkeyup="var reg = /^[a-zA-Z]+$/;if(!reg.test(this.value)) this.value='';" :validate-event="false" :disabled="propertyNumDisabled" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="组合数量:" style="margin-top:20px;" v-if="propertyNum !='1'">
            <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="combinationNum" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="显示顺序:" style="margin-top:20px;">
            <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="displayOrder" style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="是否必填:" prop="isRequired" style="margin-top:20px;">
            <el-radio v-model="isRequired" label="0">是</el-radio>
            <el-radio v-model="isRequired" label="1">否</el-radio>
          </el-form-item>
          <div class="addinpBox" v-for="(item,index) in feePropertyFrom.propertyArr" :key="item.key">
            <el-divider content-position='center'></el-divider>
            <el-form-item label="属性名称:" :key="'attrName'+item.key" :prop="'propertyArr.' + index + '.attrName'" :rules="[
              { required: true, message: '属性名称不能为空', trigger: 'blur' },
            ]" style="margin-top:20px;">
              <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="item.attrName" style="width:200px;"></el-input>
            </el-form-item>
            <!-- :prop="'propertyArr.' + index + '.dsourceFlg'"
            :rules="[
              { required: true, message: '数据源不能为空', trigger: 'blur' },
            ]" -->
            <el-form-item label="数据源:" :key="'dsourceFlg'+item.key" style="margin-top:20px;">
              <el-select v-model="item.dsourceFlg" @change="dataSourceChange(index)" clearable :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in dataSourceOptions" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="接口地址:" :key="'dataSource'+item.key" :prop="'propertyArr.' + index + '.dataSource'" :rules="[
              { required: true, message: '接口地址不能为空', trigger: 'blur' },
            ]" style="margin-top:20px;" v-if="item.dsourceFlg == '1'">
              <el-input placeholder="" maxlength="" :validate-event="false" v-model.trim="item.dataSource" style="width:200px;"></el-input>
            </el-form-item>
            <el-form-item label="编码:" :key="'dataSource'+item.key" :prop="'propertyArr.' + index + '.dataSource'" :rules="[
              { required: true, message: '编码不能为空', trigger: 'change' },
            ]" style="margin-top:20px;" v-if="item.dsourceFlg == '2'">
              <el-select v-model="item.dataSource" :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in codeOptions" :key="index" :label="item.showName2" :value="item.showName2">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据类型:" :key="'attrDatatype'+item.key" :prop="'propertyArr.' + index + '.attrDatatype'" :rules="[
              { required: true, message: '数据类型不能为空', trigger: 'change' },
            ]" style="margin-top:20px;">
              <el-select v-model="item.attrDatatype" :validate-event="false" @change="attrDatatypeChange" :disabled="datatypeDisabled" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in dataTypeOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="字段长度:" :key="'attrLength'+item.key" :prop="'propertyArr.' + index + '.attrLength'" :rules="[
              { required: true, message: '字段长度不能为空', trigger: 'blur' },
            ]" style="margin-top:20px;">
              <el-input placeholder="" maxlength="" v-model="item.attrLength" size="mini" :disabled="ZiDuanLengthDisabled" style="width:200px;"></el-input>
            </el-form-item>
            <el-form-item label="交互控件:" :key="'interControl'+item.key" :prop="'propertyArr.' + index + '.interControl'" :rules="[
              { required: true, message: '交互控件不能为空', trigger: 'change' },
            ]" style="margin-top:20px;">
              <el-select v-model="item.interControl" :validate-event="false" placeholder="请选择" style="width:200px;">
                <el-option v-for="(item,index) in interactiveOptions" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>

          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' @click="addSpuShuXingSubmit('feePropertyFrom')" v-if="addShuXingShow" :loading='addShengChengLoading'>保存</el-button>
        <el-button type="primary" size='mini' @click="changeSpuShuXingSubmit('feePropertyFrom')" v-if="changeShuXingShow" :loading='changeShengChengLoading'>修改</el-button>
        <el-button @click="addSpuShuXingClose('feePropertyFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  feeInfoAdd, // 费目新增
  feeInfoList, // 费目列表
  getAllTenantData, // 获取租户
  checkSkuExist, // 判断费目能否修改
  feeInfoUpdateStatus, // 费目启用停用
  feeInfoUpdate, // 费目修改
  feeCheckAttrExist, // 判断费目是否能删除
  feeDelete, // 费目删除
  feeAttributeAdd, // 费目属性新增
  feeAttributeBianMa, // 新增获取编码
  feeAttributeList, // 费目属性列表
  feeAttributeManyChange, // 组合属性修改
  feeAttributeUpdate, // 属性修改
  seeGroupType, // 下拉框数据
  feeAttributeCheckSkuExist, // 判断能否修改
  feeAttributeDelete // 属性删除
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00OB001', '000P00OB002', '000P00OB003',
        '000P00OB004', '000P00OB005', '000P00OB006',
        '000P00OB007', '000P00OB008', '000P00OB009',
        '000P00OB00A', '000P00OB00B'],
      title: '',
      h: '500px',
      detailsH: '200px',
      spuTotal: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10
      },
      statusOptions: [{
        value: '0',
        label: '启用'
      }, {
        value: '1',
        label: '停用'
      }],
      tingYongDisabled: false,
      // 新增费目
      addSpuMark: false,
      feeInfoAddFrom: {
        feeInfoAddName: '', // 费用名称
        tenant: '', // 所属租户
        tenantName: '', // 租户名称
        cost: '', // 费用业务
        costName: '', // 费用业务下拉框name值
        ext1: '0',
        ext2: '0'
      },
      tenantDataOptions: [], // 租户下拉框数据
      addSpuLoading: false,
      value: '',
      spuTableList: [],
      addSpuBtn: false,
      propertyNum: '1',
      combinationName: '',
      fieldName: '',
      combinationNum: '',
      displayOrder: '',
      isRequired: '0',
      // 新增属性
      feePropertyFrom: {
        propertyNum: '1',
        combinationName: '', // 组合名称
        fieldName: '', // 字段名
        combinationNum: '', // 组合数量
        displayOrder: '', // 显示顺序
        isRequired: '0', // 是否必填
        propertyArr: [{
          attrName: '', // 属性名称
          dsourceFlg: '', // 数据源
          dataSource: '', // 接口地址/编码
          attrDatatype: '', // 数据类型
          attrLength: '',
          interControl: '' // 交互控件
        }] // 新增属性动态表单数组
      },
      propertyNumDisabled: false, // 属性个数禁用
      ZiDuanLengthDisabled: false, // 字段长度禁用
      datatypeDisabled: false, // 数据类型禁用
      codeOptions: [], // 编码数据
      dataTypeOptions: [], // 数据类型数据
      interactiveOptions: [], // 交互控件数据
      interfaceUrlShow: false,
      codeShow: false,
      propertyNumOptions: [{
        value: '1',
        label: '1'
      }, {
        value: '2',
        label: '2'
      }, {
        value: '3',
        label: '3'
      }],
      dataSourceOptions: [{
        value: '1',
        label: '接口'
      }, {
        value: '2',
        label: '编码'
      }],
      addShuXingShow: false, // 新增属性保存按钮
      tableData: [],
      addSpuShuXingMark: false,
      costOptions: [], // 新增费目费用业务下拉框
      // 修改
      changeBtnShow: true,
      changeShuXiangBtnShow: true,
      changeMark: false,
      addShengChengLoading: false,
      addFaBuLoading: false,
      changeSpuLoading: false,
      changeSpuId: '',
      changeSpuBtn: false,
      changeShengChengLoading: false,
      changeShuXingShow: false, // 修改属性保存按钮
      changeDisabled: false,
      changeBianMaDisabled: false,
      // 新增验证
      rules: {
        feeInfoAddName: [
          { required: true, message: '费目名称不能为空', trigger: 'blur' }
        ],
        tenant: [
          { required: true, message: '所属租户不能为空', trigger: 'change' }
        ],
        cost: [
          { required: true, message: '费用业务不能为空', trigger: 'change' }
        ],
        ext1: [
          { required: true, message: '货物类型不能为空', trigger: 'change' }
        ],
        ext2: [
          { required: true, message: '适用货物类型不能为空', trigger: 'change' }
        ]
      },
      // 新增属性验证
      rules1: {
        propertyNum: [
          { required: true, message: '属性个数不能为空', trigger: 'blur' }
        ],
        combinationName: [
          { required: true, message: '组合名称不能为空', trigger: 'blur' }
        ],
        fieldName: [
          { required: true, message: '字段名不能为空', trigger: 'blur' }
        ],
        combinationNum: [
          { required: true, message: '组合数量不能为空', trigger: 'blur' }
        ],
        displayOrder: [
          { required: true, message: '显示顺序不能为空', trigger: 'blur' }
        ],
        isRequired: [
          { required: true, message: '是否必填不能为空', trigger: ['blur', 'change'] }
        ],
        attrName: [
          { required: true, message: '属性名称不能为空', trigger: 'blur' }
        ]
      },
      xuanzhongArr: [],
      currentXQ: '',
      spuSelectData: [],
      selectListId: [],
      selectListGoods: null,
      defaultSelectedId: '',
      defaultSelectedSpuName: '',
      defaultSelectedSpuCode: '',
      attributePageNo: 1,
      attributePageSize: 10,
      attributeTotal: 0,
      ziBiaoXuanZhongArr: [],
      spuId: '',
      shuXingId: '',
      baoCunData: {}, // 属性新增动态表单数据
      changeBaoCunData: {}, // 修改数据
      dataIndex: '',
      validFlgStatus: '',
      FeeTypeList: []
    }
  },
  computed: {
    disShow () {
      // 仓储业务 且卷板出库
      return this.feeInfoAddFrom.cost == '2' && this.feeInfoAddFrom.ext1 == '0'
    }
  },
  watch: {
    addSpuMark: function (val, oldval) {
      if (this.$refs['feeInfoAddFrom'] !== undefined) {
        this.$refs['feeInfoAddFrom'].resetFields()
      }
    },
    addSpuShuXingMark: function (val, oldval) {
      if (this.$refs['feePropertyFrom'] !== undefined) {
        this.$refs['feePropertyFrom'].resetFields()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.5 * pH - h - 150 + 'px'
    this.detailsH = 0.5 * pH - h2 - 160 + 'px'
  },
  created () {
    this.getfeeInfoListData(this.searchFrom)
    this.seeGroupTypes()
    this.getAllTenantData()

    this.btnFlg = getBtn(this.btnIdArr, '/smpAttribute')
  },
  methods: {
    seeGroupTypes () {
      seeGroupType({ groupNo: 'fee_type' })
        .then(res => {
          console.log(res)
          this.FeeTypeList = res
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 费目列表数据
    getfeeInfoListData () {
      feeInfoList(this.searchFrom).then(res => {
        this.spuTableList = res.list
        this.spuTotal = res.total
        this.defaultSelectedId = this.spuTableList[0].id
        this.defaultSelectedSpuName = this.spuTableList[0].spuName
        this.defaultSelectedSpuCode = this.spuTableList[0].spuCode
        if (this.spuTableList != []) {
          setTimeout(() => {
            this.$refs.spuTableList.setCurrentRow(this.$refs.spuTableList.data[0])
            this.$refs.spuTableList.toggleRowSelection(this.$refs.spuTableList.data[0])
          }, 10)
          if (this.spuTableList[0].validFlg == '1') {
            this.changeBtnShow = false
            this.changeShuXiangBtnShow = false
          } else {
            this.changeBtnShow = true
            this.changeShuXiangBtnShow = true
          }
        }
        this.getFeeAttributeList()
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {
        // DonMessage.error(err.message)
      })
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.spuTableList.toggleRowSelection(row)
      this.spuId = row.id
      this.getFeeAttributeList() // 子表数据
      // if(row.validFlg == '1'){
      //   this.changeBtnShow = false
      //   this.changeShuXiangBtnShow = false
      // }else{
      //   this.changeBtnShow = true
      //   this.changeShuXiangBtnShow = true
      // }
    },
    // 点击子表选中需要修改的行
    dianjixuanzhong2 (row, column, event) {
      this.ziBiaoXuanZhongArr = []
      this.ziBiaoXuanZhongArr = row
      this.currentXQ = 1
      this.shuXingId = row.id
      this.$refs.shuXingTabRef.toggleRowSelection(row)
    },
    // 获取租户数据
    getAllTenantData () {
      getAllTenantData().then(res => {
        this.tenantDataOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取新增费目下拉框数据
    getSelectData () {
      seeGroupType({
        groupNo: 'sys_model'
      }).then(res => {
        this.costOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 新增费目
    addFeeInfoClick () {
      this.feeInfoAddFrom = {
        feeInfoAddName: '', // 费用名称
        tenant: '', // 所属租户
        cost: '', // 费用业务
        costName: '', // 费用业务下拉框name值
        ext1: '0',
        ext2: '0'
      }
      this.title = '新增费目'
      this.addSpuMark = true
      this.addSpuBtn = true
      this.changeSpuBtn = false
      this.getSelectData()
      this.getAllTenantData()
    },
    // 新增费目保存
    addFeeInfoSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addSpuLoading = true
          this.costOptions.forEach((item, index) => {
            if (this.feeInfoAddFrom.cost == item.itemNo) {
              this.feeInfoAddFrom.costName = item.showName
            }
          })
          this.tenantDataOptions.forEach((item, index) => {
            if (this.feeInfoAddFrom.tenant == item.tenantCode) {
              this.feeInfoAddFrom.tenantName = item.tenantName
            }
          })
          if (!this.disShow) {
            this.feeInfoAddFrom.ext2 = '0'
          }
          feeInfoAdd({
            feeName: this.feeInfoAddFrom.feeInfoAddName, // 费目名称
            tenantUnder: this.feeInfoAddFrom.tenant, // 所属租户编码
            tenantName: this.feeInfoAddFrom.tenantName, // 所属租户
            sysModel: this.feeInfoAddFrom.cost, // 所属业务板块code
            sysName: this.feeInfoAddFrom.costName, // 所属业务名称
            ext1: this.feeInfoAddFrom.ext1, // 货物类型标识
            ext2: this.feeInfoAddFrom.ext2
          }).then(res => {
            DonMessage.success('添加成功！')
            this.feeInfoAddFrom = {
              feeInfoAddName: '', // 费用名称
              tenant: '', // 所属租户
              cost: '', // 费用业务
              costName: '' // 费用业务下拉框name值
            }
            this.getfeeInfoListData(this.searchFrom)
            this.addSpuLoading = false
            this.addSpuMark = false
          }).catch(err => {
            this.addSpuLoading = false
            DonMessage.error(err.message)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 新增费目取消按钮
    addSpuClose (formName) {
      this.addSpuMark = false
      // this.$refs[formName].resetFields();
      this.feeInfoAddFrom = {
        feeInfoAddName: '', // 费用名称
        tenant: '', // 所属租户
        cost: '', // 费用业务
        costName: '' // 费用业务下拉框name值
      }
    },
    // 点击查询
    feeChaXun () {
      this.getfeeInfoListData(this.searchFrom)
    },
    // 点击重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10
      }
      this.getfeeInfoListData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getfeeInfoListData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getfeeInfoListData(this.searchFrom)
    },
    // 点击启用，停用
    startOrStopClick (row) {
      if (row.validFlg == '0') {
        checkSkuExist({
          feeId: row.id
        }).then(res => {
          if (res > 0) {
            this.$message.error('此条数据不能停用！')
            // this.tingYongDisabled = true
          } else {
            let status = ''
            if (row.validFlg == '0') {
              status = '1'
            } else {
              status = '0'
            }
            this.$confirm('是否确定此操作？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                feeInfoUpdateStatus({
                  id: row.id, //  字典表id
                  validFlg: status
                })
                  .then(res => {
                    DonMessage.success('操作成功!')
                    this.getfeeInfoListData(this.searchFrom)
                  })
                  .catch(err => {
                    DonMessage.error(err.message)
                  })
              })
              .catch(() => { })
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        // this.tingYongDisabled = false
        let status = ''
        if (row.validFlg == '0') {
          status = '1'
        } else {
          status = '0'
        }
        this.$confirm('是否确定此操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            feeInfoUpdateStatus({
              id: row.id, //  字典表id
              validFlg: status
            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.getfeeInfoListData(this.searchFrom)
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          })
          .catch(() => { })
      }
    },
    // 点击费目修改按钮
    spuChangeClick () {
      this.getSelectData()
      // console.log(this.xuanzhongArr, '000')
      // this.spuSelectData = this.$refs.spuTableList.selection
      // console.log(this.spuSelectData, '1111')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.validFlg == '0') {
        this.$message.error('只能修改停用状态的数据！')
      } else {
        // this.spuSelectData.forEach((item, index) => {
        //   this.changeSpuId = item.id
        // })
        checkSkuExist({
          feeId: this.xuanzhongArr.id
        }).then(res => {
          if (res > 0) {
            this.$message.error('此条数据不能修改！')
            // this.tingYongDisabled = true
          } else {
            this.addSpuMark = true
            this.title = '修改类别'
            this.addSpuBtn = false
            this.changeSpuBtn = true
            // this.tingYongDisabled = false
            this.changeSpuId = this.xuanzhongArr.id
            this.costOptions.forEach((item, index) => {
              if (this.feeInfoAddFrom.cost == item.itemNo) {
                this.feeInfoAddFrom.costName = item.showName
              }
            })
            // this.spuSelectData.forEach((item, index) => {
            //   this.feeInfoAddFrom.feeInfoAddName = item.feeName
            //   this.feeInfoAddFrom.tenant = item.tenantUnder
            //   this.feeInfoAddFrom.cost = item.sysModel
            //   // this.changeSpuId = item.id
            // })
            this.feeInfoAddFrom = {
              feeInfoAddName: '', // 费用名称
              tenant: '', // 所属租户
              cost: '', // 费用业务
              costName: '', // 费用业务下拉框name值
              ext1: ''
            }
            this.$set(this.feeInfoAddFrom, 'feeInfoAddName', this.xuanzhongArr.feeName)
            this.$set(this.feeInfoAddFrom, 'tenant', this.xuanzhongArr.tenantUnder)
            this.$set(this.feeInfoAddFrom, 'cost', this.xuanzhongArr.sysModel)
            this.$set(this.feeInfoAddFrom, 'ext1', this.xuanzhongArr.ext1)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },
    // 点击spu修改保存
    changeSpuSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.costOptions.forEach((item, index) => {
            if (this.feeInfoAddFrom.cost == item.itemNo) {
              this.feeInfoAddFrom.costName = item.showName
            }
          })
          this.tenantDataOptions.forEach((item, index) => {
            if (this.feeInfoAddFrom.tenant == item.tenantCode) {
              this.feeInfoAddFrom.tenantName = item.tenantName
            }
          })
          this.changeSpuLoading = true
          feeInfoUpdate({
            id: this.changeSpuId,
            feeName: this.feeInfoAddFrom.feeInfoAddName, // 费目名称
            tenantUnder: this.feeInfoAddFrom.tenant, // 所属租户编码
            tenantName: this.feeInfoAddFrom.tenantName, // 所属租户
            sysModel: this.feeInfoAddFrom.cost, // 所属业务板块code
            sysName: this.feeInfoAddFrom.costName, // 所属业务名称
            ext1: this.feeInfoAddFrom.ext1,
            ext2: this.feeInfoAddFrom.ext2 // 适用货物类型
          }).then(res => {
            this.changeSpuLoading = false
            DonMessage.success('修改成功!')
            this.feeInfoAddFrom = {
              feeInfoAddName: '', // 费用名称
              tenant: '', // 所属租户
              cost: '', // 费用业务
              costName: '' // 费用业务下拉框name值
            }
            this.addSpuMark = false
            this.getfeeInfoListData(this.searchFrom)
          }).catch(err => {
            DonMessage.error(err.message)
            this.changeSpuLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 点击spu删除按钮
    spuDelBtnClick () {
      // let spuDelData = this.$refs.spuTableList.selection
      // let id = ''
      // spuDelData.forEach((item, index) => {
      //   id = item.id
      // })
      // console.log(this.xuanzhongArr, '22222')
      if (this.xuanzhongArr.length < 1) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        feeCheckAttrExist({
          feeId: this.xuanzhongArr.id || this.defaultSelectedId
        }).then(res => {
          if (res > 0) {
            DonMessage.error('此条数据不能删除')
          } else {
            this.$confirm('是否确定此操作？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                feeDelete({
                  id: this.xuanzhongArr.id, //  字典表id  !=0 不让删
                  feeId: this.xuanzhongArr.id || this.defaultSelectedId
                })
                  .then(res => {
                    DonMessage.success('操作成功!')
                    this.getfeeInfoListData(this.searchFrom)
                  })
                  .catch(err => {
                    DonMessage.error(err.message)
                  })
              })
              .catch(() => { })
          }
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }
    },
    // 属性删除
    delShuXingClick () {
      let spuShuXingDelData = this.$refs.shuXingTabRef.selection
      if (spuShuXingDelData.length < 1) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        feeAttributeCheckSkuExist({
          feeId: this.xuanzhongArr.id || this.defaultSelectedId
        }).then(res => {
          if (res > 0) {
            DonMessage.error('此条数据不能删除')
          } else {
            this.$confirm('是否确定此操作？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                feeAttributeDelete({
                  id: this.shuXingId, //  字典表id  !=0 不让删
                  feeId: this.xuanzhongArr.id || this.defaultSelectedId
                })
                  .then(res => {
                    DonMessage.success('操作成功!')
                    this.getFeeAttributeList()
                  })
                  .catch(err => {
                    DonMessage.error(err.message)
                  })
              })
              .catch(() => { })
          }
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }
    },
    // 获取属性列表
    getFeeAttributeList () {
      feeAttributeList({
        feeId: this.xuanzhongArr.id || this.defaultSelectedId,
        pageNo: this.attributePageNo,
        pageSize: this.attributePageSize
      }).then(res => {
        this.tableData = res.list
        this.attributeTotal = res.total
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 子表分页
    handleSizeChange2 (val) {
      this.attributePageSize = val
      this.getFeeAttributeList()
    },
    handleCurrentChange2 (val) {
      this.attributePageNo = val
      this.getFeeAttributeList()
    },
    // 获取新增属性编码下拉框数据
    getCodeSeleData () {
      feeAttributeBianMa({
        type: 0
      }).then(res => {
        this.codeOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取新增属性数据类型下拉框数据
    getDataTypeSeleData () {
      seeGroupType({
        groupNo: 'field_type' // 数据类型
      }).then(res => {
        this.dataTypeOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取新增属性交互控件下拉框数据
    getInteractiveSeleData () {
      seeGroupType({
        groupNo: 'inter_control' // 交互控件
      }).then(res => {
        this.interactiveOptions = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    // 点击添加属性按钮
    addShuXIngClick () {
      this.addSpuShuXingMark = true
      this.title = '新增属性'
      this.addShuXingShow = true
      this.changeShuXingShow = false
      this.changeDisabled = false
      this.ZiDuanLengthDisabled = false
      this.changeBianMaDisabled = true
      this.datatypeDisabled = false
      this.propertyNumDisabled = false
      this.getCodeSeleData()
      this.getDataTypeSeleData()
      this.getInteractiveSeleData()
      this.propertyNum = '1'
      this.combinationName = ''
      this.fieldName = ''
      this.combinationNum = ''
      this.displayOrder = ''
      this.isRequired = '0'
      this.feePropertyFrom = {
        propertyNum: '1',
        combinationName: '', // 组合名称
        fieldName: '', // 字段名
        combinationNum: '', // 组合数量
        displayOrder: '', // 显示顺序
        isRequired: '0', // 是否必填
        propertyArr: [{
          attrName: '', // 属性名称
          dsourceFlg: '', // 数据源
          dataSource: '', // 接口地址/编码
          attrDatatype: '', // 数据类型
          attrLength: '', // 字段长度
          interControl: '' // 交互控件
        }] // 新增属性动态表单数组
      }
    },
    // 数据类型是日期字段长度默认0
    attrDatatypeChange (val) {
      if (val == '4') {
        this.ZiDuanLengthDisabled = true
        this.feePropertyFrom.propertyArr.forEach((item, index) => {
          item.attrLength = 0
        })
      } else {
        this.ZiDuanLengthDisabled = false
      }
    },
    // 属性个数下拉框的值改变时触发的事件
    propertyNumChange (number) {
      // 数组的长度等于属性的个数
      let length = this.feePropertyFrom.propertyArr.length
      if (number > length) {
        for (let i = 0; i < number - length; i++) {
          this.feePropertyFrom.propertyArr.push({
            attrName: '', // 属性名称
            dsourceFlg: '', // 数据源
            dataSource: '', // 接口地址/编码
            attrDatatype: '', // 数据类型
            attrLength: '', // 字段长度
            interControl: '', // 交互控件
            key: Date.now()
          })
        }
      }
      if (number < length) {
        this.feePropertyFrom.propertyArr = this.feePropertyFrom.propertyArr.slice(0, number)
      }
    },
    // 数据源下拉框数据改变时
    dataSourceChange (index) {
      // console.log(index,'////')
      this.dataIndex = index
      this.feePropertyFrom.propertyArr[this.dataIndex].dataSource = ''
      // console.log(this.feePropertyFrom.propertyArr[this.dataIndex],'3333')
    },
    // 新增属性确认
    addSpuShuXingSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.propertyNum > '1' && this.combinationName == '') {
            DonMessage.error('组合名称不能为空！')
          } else if (this.fieldName == '') {
            DonMessage.error('字段名名称不能为空！')
          } else if (this.propertyNum > '1' && this.combinationNum == '') {
            DonMessage.error('组合数量不能为空！')
          } else if (this.displayOrder == '') {
            DonMessage.error('显示顺序不能为空！')
          } else {
            this.addShengChengLoading = true
            // 组装数据  obj arr
            this.baoCunData = {
              feeId: this.xuanzhongArr.id || this.defaultSelectedId,
              attributeNum: this.propertyNum, // 属性个数
              compositeName: this.combinationName, // 组合名称
              attrStandard: this.fieldName, // 字段名
              compositeNum: this.combinationNum, // 组合数量
              orderBy: this.displayOrder, // 显示顺序
              isnotFlg: this.isRequired, // 是否必填
              list: []
            }
            this.feePropertyFrom.propertyArr.forEach((item, index) => {
              const obj = {
                attrName: item.attrName, // 属性名称
                dsourceFlg: item.dsourceFlg, // 数据源
                dataSource: item.dataSource, // 接口/编码
                attrDatatype: item.attrDatatype, // 数据类型
                attrLength: item.attrLength, // 字段长度
                interControl: item.interControl // 交互控件
              }
              this.baoCunData.list.push(obj)
            })
            feeAttributeAdd(this.baoCunData).then(res => {
              DonMessage.success('添加成功!')
              this.addShengChengLoading = false
              this.addSpuShuXingMark = false
              this.propertyNum = '1'
              this.combinationName = ''
              this.fieldName = ''
              this.combinationNum = ''
              this.displayOrder = ''
              this.isRequired = '0'
              this.feePropertyFrom = {
                propertyNum: '1',
                combinationName: '', // 组合名称
                fieldName: '', // 字段名
                combinationNum: '', // 组合数量
                displayOrder: '', // 显示顺序
                isRequired: '0', // 是否必填
                propertyArr: [{
                  attrName: '', // 属性名称
                  dsourceFlg: '', // 数据源
                  dataSource: '', // 接口地址/编码
                  attrDatatype: '', // 数据类型
                  attrLength: '', // 字段长度
                  interControl: '' // 交互控件
                }] // 新增属性动态表单数组
              }
              this.getFeeAttributeList()
            }).catch(err => {
              DonMessage.error(err.message)
              this.addShengChengLoading = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 新增属性取消
    addSpuShuXingClose (formName) {
      this.addSpuShuXingMark = false
      // this.$refs[formName].resetFields();
      this.propertyNum = '1'
      this.combinationName = ''
      this.fieldName = ''
      this.combinationNum = ''
      this.displayOrder = ''
      this.isRequired = '0'
      this.feePropertyFrom = {
        propertyNum: '1',
        combinationName: '', // 组合名称
        fieldName: '', // 字段名
        combinationNum: '', // 组合数量
        displayOrder: '', // 显示顺序
        isRequired: '0', // 是否必填
        propertyArr: [{
          attrName: '', // 属性名称
          dsourceFlg: '', // 数据源
          dataSource: '', // 接口地址
          ext3: '', // 编码
          attrDatatype: '', // 数据类型
          attrLength: '', // 字段长度
          interControl: '' // 交互控件
        }] // 新增属性动态表单数组
      }
      this.interfaceUrlShow = false
      this.codeShow = false
    },
    // 点击修改属性
    changeShuXingClick () {
      // this.ziBiaoXuanZhongArr = this.$refs.shuXingTabRef.selection
      // || this.defaultSelectedId
      console.log(this.xuanzhongArr.id, '3333')
      if (this.xuanzhongArr.id == undefined) {
        this.$message.error('请选择一条费目进行操作！')
      } else if (this.ziBiaoXuanZhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        feeAttributeCheckSkuExist({
          feeId: this.xuanzhongArr.id
        }).then(res => {
          if (res > '0') {
            // this.$message.error('此条数据不能修改！')
            this.addSpuShuXingMark = true
            this.title = '修改类别属性'
            this.changeShuXingShow = true
            this.addShuXingShow = false
            this.propertyNumDisabled = true
            this.datatypeDisabled = true
            this.getCodeSeleData()
            this.getDataTypeSeleData()
            this.getInteractiveSeleData()
            this.propertyNum = ''
            // 赋值
            this.propertyNum = this.ziBiaoXuanZhongArr.attributeNum
            // this.$set(this.feePropertyFrom, 'propertyNum', this.ziBiaoXuanZhongArr.attributeNum)
            // this.propertyNum = this.ziBiaoXuanZhongArr.attributeNum  // 属性个数
            this.combinationName = this.ziBiaoXuanZhongArr.compositeName // 组名名称
            this.fieldName = this.ziBiaoXuanZhongArr.attrStandard // 字段名
            this.combinationNum = this.ziBiaoXuanZhongArr.compositeNum // 组合数量
            this.displayOrder = this.ziBiaoXuanZhongArr.orderBy // 显示顺序
            this.isRequired = this.ziBiaoXuanZhongArr.isnotFlg + '' // 是否必填
            // 判断是否是组合属性, 是组合属性另外调接口
            if (this.ziBiaoXuanZhongArr.attributeNum > '1') {
              feeAttributeManyChange({
                feeId: this.xuanzhongArr.id || this.defaultSelectedId,
                attrCode: this.ziBiaoXuanZhongArr.attrCode
              }).then(res => {
                this.feePropertyFrom.propertyArr = res
              }).catch(err => {
                DonMessage.error(err.message)
              })
            } else {
              this.$nextTick(function () {
                this.feePropertyFrom.propertyArr[0].attrName = this.ziBiaoXuanZhongArr.attrName // 属性名称
                this.feePropertyFrom.propertyArr[0].dsourceFlg = this.ziBiaoXuanZhongArr.dsourceFlg // 数据源
                this.feePropertyFrom.propertyArr[0].dataSource = this.ziBiaoXuanZhongArr.dataSource // 接口/编码
                this.feePropertyFrom.propertyArr[0].attrDatatype = this.ziBiaoXuanZhongArr.attrDatatype // 数据类型
                this.feePropertyFrom.propertyArr[0].attrLength = this.ziBiaoXuanZhongArr.attrLength // 字段长度
                this.feePropertyFrom.propertyArr[0].interControl = this.ziBiaoXuanZhongArr.interControl // 交互控件
              })
            }
          } else {
            this.addSpuShuXingMark = true
            this.title = '修改类别属性'
            this.changeShuXingShow = true
            this.addShuXingShow = false
            this.propertyNumDisabled = true
            this.getCodeSeleData()
            this.getDataTypeSeleData()
            this.getInteractiveSeleData()
            this.propertyNum = ''
            // 赋值
            this.propertyNum = this.ziBiaoXuanZhongArr.attributeNum
            // this.$set(this.feePropertyFrom, 'propertyNum', this.ziBiaoXuanZhongArr.attributeNum)
            // this.propertyNum = this.ziBiaoXuanZhongArr.attributeNum  // 属性个数
            this.combinationName = this.ziBiaoXuanZhongArr.compositeName // 组名名称
            this.fieldName = this.ziBiaoXuanZhongArr.attrStandard // 字段名
            this.combinationNum = this.ziBiaoXuanZhongArr.compositeNum // 组合数量
            this.displayOrder = this.ziBiaoXuanZhongArr.orderBy // 显示顺序
            this.isRequired = this.ziBiaoXuanZhongArr.isnotFlg + '' // 是否必填
            // 判断是否是组合属性, 是组合属性另外调接口
            if (this.ziBiaoXuanZhongArr.attributeNum > '1') {
              feeAttributeManyChange({
                feeId: this.xuanzhongArr.id || this.defaultSelectedId,
                attrCode: this.ziBiaoXuanZhongArr.attrCode
              }).then(res => {
                this.feePropertyFrom.propertyArr = res
              }).catch(err => {
                DonMessage.error(err.message)
              })
            } else {
              this.$nextTick(function () {
                this.feePropertyFrom.propertyArr[0].attrName = this.ziBiaoXuanZhongArr.attrName // 属性名称
                this.feePropertyFrom.propertyArr[0].dsourceFlg = this.ziBiaoXuanZhongArr.dsourceFlg // 数据源
                this.feePropertyFrom.propertyArr[0].dataSource = this.ziBiaoXuanZhongArr.dataSource // 接口/编码
                this.feePropertyFrom.propertyArr[0].attrDatatype = this.ziBiaoXuanZhongArr.attrDatatype // 数据类型
                this.feePropertyFrom.propertyArr[0].attrLength = this.ziBiaoXuanZhongArr.attrLength // 字段长度
                this.feePropertyFrom.propertyArr[0].interControl = this.ziBiaoXuanZhongArr.interControl // 交互控件
              })
            }
          }
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }
    },
    // 点击修改属性确定
    changeSpuShuXingSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeShengChengLoading = true
          // 组装数据  obj arr
          this.changeBaoCunData = {
            feeId: this.xuanzhongArr.id || this.defaultSelectedId,
            attributeNum: this.propertyNum, // 属性个数
            compositeName: this.combinationName, // 组合名称
            attrStandard: this.fieldName, // 字段名
            compositeNum: this.combinationNum, // 组合数量
            orderBy: this.displayOrder, // 显示顺序
            isnotFlg: this.isRequired, // 是否必填
            list: []
          }
          this.feePropertyFrom.propertyArr.forEach((item, index) => {
            let id = ''
            if (this.feePropertyFrom.propertyArr.length > '1') {
              id = item.id
            } else {
              id = this.shuXingId
            }
            const obj = {
              id: id,
              attrName: item.attrName, // 属性名称
              dsourceFlg: item.dsourceFlg, // 数据源
              dataSource: item.dataSource, // 接口/编码
              attrDatatype: item.attrDatatype, // 数据类型
              attrLength: item.attrLength, // 字段长度
              interControl: item.interControl // 交互控件
            }
            this.changeBaoCunData.list.push(obj)
          })
          feeAttributeUpdate(this.changeBaoCunData).then(res => {
            DonMessage.success('操作成功!')
            this.changeShengChengLoading = false
            this.addSpuShuXingMark = false
            this.propertyNum = '1'
            this.combinationName = ''
            this.fieldName = ''
            this.combinationNum = ''
            this.displayOrder = ''
            this.isRequired = '0'
            this.feePropertyFrom = {
              propertyNum: '1',
              combinationName: '', // 组合名称
              fieldName: '', // 字段名
              combinationNum: '', // 组合数量
              displayOrder: '', // 显示顺序
              isRequired: '0', // 是否必填
              propertyArr: [{
                attrName: '', // 属性名称
                dsourceFlg: '', // 数据源
                dataSource: '', // 接口地址/ 编码
                attrDatatype: '', // 数据类型
                attrLength: '', // 字段长度
                interControl: '' // 交互控件
              }] // 新增属性动态表单数组
            }
            this.getFeeAttributeList()
          }).catch(err => {
            DonMessage.error(err.message)
            this.changeShengChengLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 点击设置跳转页面
    setUp (row) {
      localStorage.setItem('feeId', row.id)
      this.$router.push('/setDetails')
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox {
  margin: 10px 0 0 -30px;
}
.inpBox .el-date-editor {
  width: 260px !important;
}
/deep/ .inpBox .el-range-editor--mini .el-input__inner {
  width: 150px;
}
.searchBox {
  margin-left: 10px;
}
.searchBtnBox {
  margin-top: 10px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tiHuoDanGuanLiWarp-body-table {
  margin-top: 5px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
